import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgPaypalSolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.086 3.115a1.75 1.75 0 0 0-1.73 1.48L3.44 16.865a1.75 1.75 0 0 0 1.73 2.02h2.403a1.75 1.75 0 0 0 1.733 1.997h2.271a1.75 1.75 0 0 0 1.726-1.463l.542-3.253a.25.25 0 0 1 .247-.209h1.615a4.854 4.854 0 0 0 1.16-9.567 5.207 5.207 0 0 0-4.838-3.275H7.085Zm10.15 5.21c0-.07 0-.14-.004-.208.551.282 1.015.713 1.337 1.24a3.354 3.354 0 0 1-2.863 5.1h-1.615a1.75 1.75 0 0 0-1.726 1.463l-.542 3.253a.25.25 0 0 1-.247.209H9.305a.25.25 0 0 1-.248-.286l.142-.835v-.002l.753-4.516a.25.25 0 0 1 .246-.209h1.829a5.21 5.21 0 0 0 5.21-5.21Z",
  fill: "currentColor"
})));

export { SvgPaypalSolid as default };
